// const END_URL = 'https://personalitypeek.staging3.dotwibe.com/api/api';

// const ASSET_URL = 'https://personalitypeek.staging3.dotwibe.com/api/public';

// const IMG_URL = 'https://personalitypeek.staging3.dotwibe.com/api';

// const SITE_URL = 'https://personalitypeek.staging3.dotwibe.com';

const END_URL = 'https://personalitypeek.com/api/api';

const ASSET_URL = 'https://personalitypeek.com/api/public';

const IMG_URL = 'https://personalitypeek.com/api';

const SITE_URL = 'https://personalitypeek.com';

export  { END_URL, IMG_URL,ASSET_URL,SITE_URL} ;